import { AvailableConfigs, InfographicConfig } from "../types";
import antarcticaBridgeInfographicConfig from "./antarcticaBridgeInfographicConfig";
import defaultInfographicConfig from "./defaultInfographicConfig";

export const infographicConifg = (
  name?: AvailableConfigs
): InfographicConfig => {
  switch (name) {
    case "antarcticaBridge":
      return antarcticaBridgeInfographicConfig;
    default:
      return defaultInfographicConfig;
  }
};
